import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ThemeRtlProvider from './ThemeRtlProvider';
import AppBar from '../ui/header/header';
import Footer from '../ui/footer/footer';

const styles = {
  root: {
    display: 'block',
  },
  content: {
    flexGrow: 1,
    backgroundColor: '#fff',
    minHeight: '90vh',
  },
};

const LayoutWithSidebar = ({ classes, component: Component, loggedInUser }) => (
  <ThemeRtlProvider>
    <AppBar loggedInUser={loggedInUser} />
    <div className={classes.root}>
      <main className={classes.content}>
        <Component />
      </main>
    </div>
    <Footer />
  </ThemeRtlProvider>
);

LayoutWithSidebar.defaultProps = {
  loggedInUser: null,
};

LayoutWithSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object,
};

export default withStyles(styles)(LayoutWithSidebar);
